import { NavLink } from "react-router-dom";
import { haptics } from "../lib/telegram";

const TABS = [
  { to: "/", label: "Search", icon: "🔍", end: true },
  { to: "/browse", label: "Browse", icon: "▦", end: false },
  { to: "/collections", label: "Collections", icon: "🗂", end: false },
  { to: "/profile", label: "Profile", icon: "👤", end: false },
];

/** Always-visible bottom tab bar (frontend.md). Safe-area padded; haptic on tab
 *  change. */
export function BottomNav() {
  return (
    <nav
      className="sticky bottom-0 z-30 flex border-t border-tg-separator bg-tg-bg-bottom"
      style={{ paddingBottom: "max(8px, var(--safe-bottom))" }}
    >
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          onClick={() => haptics.select()}
          className={({ isActive }) =>
            "flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] transition-opacity " +
            (isActive ? "text-tg-accent" : "text-tg-hint")
          }
        >
          <span className="text-lg leading-none">{t.icon}</span>
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
